import { render, staticRenderFns } from "./noticeTable.vue?vue&type=template&id=b0cc1398"
import script from "./noticeTable.vue?vue&type=script&lang=js"
export * from "./noticeTable.vue?vue&type=script&lang=js"
import style0 from "./noticeTable.vue?vue&type=style&index=0&id=b0cc1398&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports